// @ts-nocheck
import TAG_DICT from "./dataDictionary";
import uids from "./uids";

const maxLength = 128;

function mapUid(str) {
  var uid = uids[str];
  if (uid) {
    return " [ " + uid + " ]";
  }
  return "";
}

// helper function to see if a string only has ascii characters in it
function isASCII(str) {
  return /^[\x00-\x7F]*$/.test(str);
}
/**
 * @function dumpDataSet
 * @description  This function iterates through dataSet recursively and adds new HTML strings
 *               to the output array passed into it
 * @ref @see https://github.com/cornerstonejs/dicomParser/blob/master/examples/dumpWithDataDictionary/index.html
 * @param {*} dataSet
 * @param {*} output
 */
export default function dumpDataSet(dataSet, output) {
  function getTag(tag) {
    var group = tag.substring(1, 5);
    var element = tag.substring(5, 9);
    var tagIndex = ("(" + group + "," + element + ")").toUpperCase();
    var attr = TAG_DICT[tagIndex];
    return attr;
  }
  try {
    var keys = [];
    for (var propertyName in dataSet.elements) {
      if (
        propertyName === "null" ||
        propertyName === "undefined" ||
        propertyName === "0x7FE00010"
      ) {
        continue;
      }
      keys.push(propertyName);
    }
    keys.sort();
    // the dataSet.elements object contains properties for each element parsed.  The name of the property
    // is based on the elements tag and looks like 'xGGGGEEEE' where GGGG is the group number and EEEE is the
    // element number both with lowercase hexadecimal letters.  For example, the Series Description DICOM element 0008,103E would
    // be named 'x0008103e'.  Here we iterate over each property (element) so we can build a string describing its
    // contents to add to the output array
    for (var k = 0; k < keys.length; k++) {
      let elementJson = {
        tagId: "",
        vr: "",
        vm: "",
        length: "",
        description: "",
        value: "",
      };

      let propertyName = keys[k];
      var element = dataSet.elements[propertyName];
      let renameTag = "";
      if (element.tag[0] === "0") {
        renameTag = element.tag.slice(1);
      } else {
        renameTag = element.tag;
      }
      ///
      /// 1. get tag id
      //
      //var tag = getTag(element.tag);
      var tag = getTag(renameTag);

      // The output string begins with the element name (or tag if not in data dictionary), length and VR (if present).  VR is undefined for
      // implicit transfer syntaxes
      if (tag === undefined) {
        ///
        /// 2-1. get length
        ///
        elementJson.length = element.length;

        // var groupId = element.tag.substring(1, 5);
        // var elementId = element.tag.substring(5, 9);
        var groupId = renameTag.substring(1, 5);
        var elementId = renameTag.substring(5, 9);
        var tagIndex = ("(" + groupId + "," + elementId + ")").toUpperCase();
        elementJson.tagId = tagIndex;
        if (element.hadUndefinedLength) {
        }
        if (element.vr) {
          elementJson.vr = element.vr;
        }
      } else {
        elementJson.tagId = tag.tag;
        elementJson.description = tag.name;
        elementJson.vm = tag.vm;
        elementJson.vr = tag.vr;

        elementJson.length = element.length;
        if (element.vr) {
          elementJson.vr = element.vr;
        }
      }

      // Here we check for Sequence items and iterate over them if present.  items will not be set in the
      // element object for elements that don't have SQ VR type.  Note that implicit little endian
      // sequences will are currently not parsed.
      if (element.items) {
        // each item contains its own data set so we iterate over the items
        // and recursively call this function
        // eslint-disable-next-line no-loop-func
        element.items.forEach(function (item) {
          let elementItemJson = {
            tagId: "",
            vr: "",
            vm: "",
            length: "",
            description: "",
            value: "",
          };

          elementItemJson.tagId = item.tag;
          elementItemJson.description = "Item";
          elementItemJson.length = item.length;

          // output.push("<li>Item #" + itemNumber++ + " " + item.tag);
          // var lengthText = " length=" + item.length;
          // if (item.hadUndefinedLength) {
          //   lengthText += " (-1)";
          // }
          //text += lengthText + "; ";
          //output.push(lengthText);

          //output.push("</li>");
          //output.push("<ul>");

          // 임시 배제
          //dumpDataSet(item.dataSet, output);
          //output.push("</ul>");
        });
        //output.push("</ul>");
      } else if (element.fragments) {
        // text +=
        //   "encapsulated pixel data with " +
        //   element.basicOffsetTable.length +
        //   " offsets and " +
        //   element.fragments.length +
        //   " fragments";
        // text += sha1Text(dataSet.byteArray, element.dataOffset, element.length);
        // output.push("<li title='" + title + "'=>" + text + "</li>");
        if (element.encapsulatedPixelData) {
          // output.push("Fragments:<br>");
          // output.push("<ul>");
          // var itemNumber = 0;
          // element.fragments.forEach(function(fragment) {
          //   var str =
          //     "<li>Fragment #" +
          //     itemNumber++ +
          //     " dataOffset = " +
          //     fragment.position;
          //   str += "; offset = " + fragment.offset;
          //   str += "; length = " + fragment.length;
          //   str += sha1Text(
          //     dataSet.byteArray,
          //     fragment.position,
          //     fragment.length
          //   );
          //   str += "</li>";
          //   output.push(str);
          // });
          // output.push("</ul>");
        }
        if (element.encapsulatedPixelData) {
          // output.push("Frames:<br>");
          // output.push("<ul>");
          // var bot = element.basicOffsetTable;
          // // if empty bot and not RLE, calculate it
          // if (bot.length === 0) {
          //   bot = dicomParser.createJPEGBasicOffsetTable(dataSet, element);
          // }
          // function imageFrameLink(frameIndex) {
          //   var linkText = "<a class='imageFrameDownload' ";
          //   linkText += "data-frameIndex='" + frameIndex + "'";
          //   linkText += " href='#'> Frame #" + frameIndex + "</a>";
          //   return linkText;
          // }
          // for (var frameIndex = 0; frameIndex < bot.length; frameIndex++) {
          //   var str = "<li>";
          //   str += imageFrameLink(frameIndex, "Frame #" + frameIndex);
          //   str +=
          //     " dataOffset = " +
          //     (element.fragments[0].position + bot[frameIndex]);
          //   str += "; offset = " + bot[frameIndex];
          //   var imageFrame = dicomParser.readEncapsulatedImageFrame(
          //     dataSet,
          //     element,
          //     frameIndex,
          //     bot
          //   );
          //   str += "; length = " + imageFrame.length;
          //   str += sha1Text(imageFrame);
          //   str += "</li>";
          //   output.push(str);
          // }
          // output.push("</ul>");
        }
      } else {
        // use VR to display the right value
        var vr;
        if (element.vr !== undefined) {
          vr = element.vr;
        } else {
          if (tag !== undefined) {
            vr = tag.vr;
          }
        }
        let text = "";
        // if the length of the element is less than 128 we try to show it.  We put this check in
        // to avoid displaying large strings which makes it harder to use.
        if (element.length < maxLength) {
          // Since the dataset might be encoded using implicit transfer syntax and we aren't using
          // a data dictionary, we need some simple logic to figure out what data types these
          // elements might be.  Since the dataset might also be explicit we could be switch on the
          // VR and do a better job on this, perhaps we can do that in another example
          // First we check to see if the element's length is appropriate for a UI or US VR.
          // US is an important type because it is used for the
          // image Rows and Columns so that is why those are assumed over other VR types.
          if (element.vr === undefined && tag === undefined) {
            //!!!!
            if (element.length === 2) {
              text += " (" + dataSet.uint16(propertyName) + ")";
            } else if (element.length === 4) {
              text += " (" + dataSet.uint32(propertyName) + ")";
            }
            // Next we ask the dataset to give us the element's data in string form.  Most elements are
            // strings but some aren't so we do a quick check to make sure it actually has all ascii
            // characters so we know it is reasonable to display it.
            var str = dataSet.string(propertyName);
            var stringIsAscii = isASCII(str);
            if (stringIsAscii) {
              // the string will be undefined if the element is present but has no data
              // (i.e. attribute is of type 2 or 3 ) so we only display the string if it has
              // data.  Note that the length of the element will be 0 to indicate "no data"
              // so we don't put anything here for the value in that case.
              if (str !== undefined) {
                text += '"' + str + '"' + mapUid(str);
              }
            } else {
              if (element.length !== 2 && element.length !== 4) {
                //color = "#C8C8C8";
                //!!!!
                // If it is some other length and we have no string
                text += "binary data";
              }
            }
          } else {
            function isStringVr(vr) {
              if (
                vr === "AT" ||
                vr === "FL" ||
                vr === "FD" ||
                vr === "OB" ||
                vr === "OF" ||
                vr === "OW" ||
                vr === "SI" ||
                vr === "SQ" ||
                vr === "SS" ||
                vr === "UL" ||
                vr === "US"
              ) {
                return false;
              }
              return true;
            }
            if (isStringVr(vr)) {
              // Next we ask the dataset to give us the element's data in string form.  Most elements are
              // strings but some aren't so we do a quick check to make sure it actually has all ascii
              // characters so we know it is reasonable to display it.
              let str = dataSet.string(propertyName);
              let stringIsAscii = isASCII(str);
              if (stringIsAscii) {
                // the string will be undefined if the element is present but has no data
                // (i.e. attribute is of type 2 or 3 ) so we only display the string if it has
                // data.  Note that the length of the element will be 0 to indicate "no data"
                // so we don't put anything here for the value in that case.
                if (str !== undefined) {
                  text += str + mapUid(str);
                }
              } else {
                if (element.length !== 2 && element.length !== 4) {
                  //color = "#C8C8C8";
                  // If it is some other length and we have no string
                  //!!!!
                  text += "binary data";
                }
              }
            } else if (vr === "US") {
              text += dataSet.uint16(propertyName);
              for (
                var i = 1;
                i < dataSet.elements[propertyName].length / 2;
                i++
              ) {
                text += "\\" + dataSet.uint16(propertyName, i);
              }
            } else if (vr === "SS") {
              text += dataSet.int16(propertyName);
              for (
                let i = 1;
                i < dataSet.elements[propertyName].length / 2;
                i++
              ) {
                text += "\\" + dataSet.int16(propertyName, i);
              }
            } else if (vr === "UL") {
              text += dataSet.uint32(propertyName);
              for (
                let i = 1;
                i < dataSet.elements[propertyName].length / 4;
                i++
              ) {
                text += "\\" + dataSet.uint32(propertyName, i);
              }
            } else if (vr === "SL") {
              text += dataSet.int32(propertyName);
              for (
                let i = 1;
                i < dataSet.elements[propertyName].length / 4;
                i++
              ) {
                text += "\\" + dataSet.int32(propertyName, i);
              }
            } else if (vr === "FD") {
              text += dataSet.double(propertyName);
              for (
                let i = 1;
                i < dataSet.elements[propertyName].length / 8;
                i++
              ) {
                text += "\\" + dataSet.double(propertyName, i);
              }
            } else if (vr === "FL") {
              text += dataSet.float(propertyName);
              for (
                let i = 1;
                i < dataSet.elements[propertyName].length / 4;
                i++
              ) {
                text += "\\" + dataSet.float(propertyName, i);
              }
            } else if (
              vr === "OB" ||
              vr === "OW" ||
              vr === "UN" ||
              vr === "OF" ||
              vr === "UT"
            ) {
              //color = "#C8C8C8";
              // If it is some other length and we have no string
              if (element.length === 2) {
                text += dataSet.uint16(propertyName);
              } else if (element.length === 4) {
                text += dataSet.uint32(propertyName);
              } else {
                text += vr;
              }
           } else if (vr === "AT") {
            // AT = 4 bytes per value (2 bytes group + 2 bytes element)
            // 빈 값/깨진 값 방어
            var el = dataSet.elements[propertyName];
            var byteLen = 0;

            if (el && el.length != null) {
              byteLen = el.length;
            } else if (element && element.length != null) {
              byteLen = element.length;
            } else {
              byteLen = 0;
            }

            if (byteLen < 4) {
              // 값이 없거나 불완전하면 표시만 하고 넘어감 (크래시 방지)
              text += "";
            } else {
              const group = dataSet.uint16(propertyName, 0);
              const elem = dataSet.uint16(propertyName, 1);

              if (group === undefined || elem === undefined) {
                text += "";
              } else {
                const groupHexStr = ("0000" + group.toString(16)).slice(-4);
                const elementHexStr = ("0000" + elem.toString(16)).slice(-4);
                text += "x" + groupHexStr + elementHexStr;
              }
            }

          } else if (vr === "SQ") {
          } else {
              // If it is some other length and we have no string
              //text += "<i>no display code for VR " + vr + " yet, sorry!</i>";
              text += "no display code for VR " + vr;
            }
          }
          if (element.length === 0) {
            //color = "#C8C8C8";
          }
        } else {
          //color = "#C8C8C8";
          // Add text saying the data is too long to show...
          // !!!
          text +=
            " length " + element.length + " for VR " + vr + " too long to show";
        }

        elementJson.value = text;
        output.push(elementJson);
      }
    }
  } catch (err) {
    var ex = {
      exception: err,
      output: output,
    };
    throw ex;
  }
}
